import React from "react";
import styled from "styled-components";

const Button=styled.div`
    font-weight:bold;
    color:black;
    text-align:center;
    cursor:pointer;
    border-radius:50%;
    height:25px;
    width:25px;
`;


const  StatusButtonLetter=({color,letter})=>
{
    return (<React.Fragment>
            <Button style={{backgroundColor:`${color}` ,border:`5px solid ${color}`}}>{letter}</Button>
        </React.Fragment>);
}

export default StatusButtonLetter;